import { cascadesign } from '../request';
export default {
  props: {
    index: {
      type: Number
    },
    formDataArray: {
      type: Array
    }
  },
  data() {
    return {
      canvasContext: null,
      signatureIMAGE: '',
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      canvasWidth: 860,
      canvasHeight: 200
    };
  },
  computed: {
    indexID() {
      // console.log(this.index);
      return this.index;
    }
  },
  mounted() {
    // console.log('获取传过来的index', this.index);
    this.canvasContext = this.$refs.canvas.getContext('2d');
    this.resizeCanvas();
    window.addEventListener('resize', this.resizeCanvas);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas);
  },
  methods: {
    // 自定义 编辑
    async getcascadesign(item) {
      this.currentOptions = await cascadesign({
        sign: item
      });
      console.log('签名', this.currentOptions);
    },
    startDrawing(event) {
      this.isDrawing = true;
      this.lastX = event.clientX - this.$refs.canvas.getBoundingClientRect().left;
      this.lastY = event.clientY - this.$refs.canvas.getBoundingClientRect().top;
    },
    draw(event) {
      if (!this.isDrawing) return;
      const x = event.clientX - this.$refs.canvas.getBoundingClientRect().left;
      const y = event.clientY - this.$refs.canvas.getBoundingClientRect().top;
      this.canvasContext.beginPath();
      this.canvasContext.lineWidth = 2; // 设置线条宽度为2像素（根据需求调整宽度）
      this.canvasContext.moveTo(this.lastX, this.lastY);
      this.canvasContext.lineTo(x, y);
      this.canvasContext.stroke();
      this.lastX = x;
      this.lastY = y;
    },
    stopDrawing() {
      this.isDrawing = false;
    },
    // 清空
    clearCanvas() {
      this.canvasContext.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.formDataArray[this.indexID].url = '';
      // this.$emit('my-event', this.formDataArray[this.indexID].url == '');
    },
    // 上传
    saveSignature() {
      // console.log(this.formDataArray); // 检查formDataArray数组
      // console.log(this.indexID); // 检查indexID的值
      const signatureData = this.$refs.canvas.toDataURL();
      this.formDataArray[this.indexID].url = signatureData;
      this.getcascadesign(this.formDataArray[this.indexID].url);

      // this.$emit('my-event', this.formDataArray[this.indexID].url);
    },
    resizeCanvas() {
      const container = this.$refs.canvas.parentElement;
      this.canvasWidth = container.offsetWidth;
      this.canvasHeight = container.offsetHeight;
      this.$refs.canvas.width = this.canvasWidth;
      this.$refs.canvas.height = this.canvasHeight;
    }
  }
};